import React from 'react';

// helpers
import {useTheme} from '@emotion/react';
import {useTranslation} from 'react-i18next';
import {useScreenWidth} from '../../../../shared/hooks';

// components
import {CardBorder, TableSubscriptions} from '../../../../shared/components';
import {CardSubscription} from './components';

// styles
import {Subtitle, TextColors} from '../../../../shared/styles';
import {
  SectionSubscriptionsDesktopWrapper,
  SectionSubscriptionsMobileWrapper,
} from './SectionSubscriptions-styles';

// types
import {Subscription} from '../../../../shared/services/ApiService/types';

type Props = {
  subscriptions: Subscription[];
};

const SectionSubscriptions = ({subscriptions}: Props) => {
  const {t} = useTranslation();
  const screenWidth = useScreenWidth();
  const theme = useTheme();

  if (screenWidth < theme.screenBreakpoint.md.value) {
    return (
      <SectionSubscriptionsMobileWrapper>
        <Subtitle bold="bold" color={TextColors.secondary}>
          {t('subscription_subscriptions')}
        </Subtitle>
        {subscriptions.map((subscription) => (
          <CardSubscription key={subscription.id} subscription={subscription} />
        ))}
      </SectionSubscriptionsMobileWrapper>
    );
  }

  return (
    <CardBorder variant="white">
      <SectionSubscriptionsDesktopWrapper>
        <Subtitle bold="bold">{t('subscription_subscriptions')}</Subtitle>
        <TableSubscriptions subscriptions={subscriptions} />
      </SectionSubscriptionsDesktopWrapper>
    </CardBorder>
  );
};

export default SectionSubscriptions;
